module.exports = __webpack_public_path__ + "static/media/ccc.cf45fa3c.png";